module.exports = __webpack_public_path__ + "img/invest_arrow@3x.d1a32989.png";